module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image05-1110x550.2caa586b.jpg";